<template>
  <section id="footer">
    <div class="container">
      <div class="grid-row">
        <div :class="`c-${col_number} c-sm-6 c-xs-6`">
          <h3>{{$_('about')}}</h3>
          <div class="column-container">
            <ul>
              <li>
                <a target="_blank" :href="`${base_url}static/catalogues/infos_legales/${this.lang}/MENTIONS LEGALES SITE MY SATAB.pdf`">{{$_('legal_mention')}}</a>
              </li>
              <li>
                <a target="_blank" :href="`${base_url}static/catalogues/infos_legales/${this.lang}/CGV FR-US SATAB - Gereral Sales Terms 18032020.pdf`">{{$_('terms_of_sales')}}</a>
              </li>
              <li>
                <a target="_blank" :href="`${base_url}static/catalogues/infos_legales/${this.lang}/POLITIQUE DE CONFIDENTIALITÉ MY SATAB.pdf`">{{$_('privacy_policy')}}</a>
              </li>
              <li>
                <a href="#">{{$_('cookies_management')}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="show_sav" :class="`c-${col_number} c-sm-6 c-xs-6`">
          <h3>{{this.TNOM}} {{this.TLPAYS}}</h3>
          <div class="column-container">
            <span>
              <a :href="`tel:+${this.TTEL_ADV}`">T : +{{this.TTEL_ADV}}</a>
            </span>
            <span class="text">F : +{{this.TFAX_ADV}}</span>
            <span class="text">
              <a :href="`mailto:${this.TMAIL_ADV}`">@ : {{this.TMAIL_ADV}}</a>
            </span>
          </div>
          <div class="column-container">
            <span>{{this.TNOM}} {{this.TLPAYS}}</span>
            <span class="text">{{this.TADR1}}</span>
            <span class="text">{{this.TADR2}}</span>
            <span class="text">{{this.TADR3}}</span>
            <span class="text">{{this.TCPOST}} {{this.TVILLE}}</span>
            <span class="text">{{this.TLPAYS}}</span>
          </div>
        </div>
        <div :class="`c-${col_number} c-sm-6 c-xs-6`">
          <h3>{{$_('accepted_payment')}}</h3>
          <div class="column-container">
            <img src="../../assets/img/footer/payment.png" alt="Paiement" />
          </div>
        </div>
        <div :class="`c-${col_number} c-sm-6 c-xs-6`">
          <h3>{{$_('satab_discover')}}</h3>
          <div class="column-container">
            <a target="_blank" href="https://www.satab.com/" class="italic">www.satab.com</a>
            <!--<a target="_blank" href="http://www.belr-exception.com/" class="italic">www.belr-exception.com</a>
            <a target="_blank" href="http://cestjoli.fr/" class="italic">www.cestjoli.fr</a>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import customerService from "@/modules/client/services/customerService";

export default {
  name: 'Footer',
  data() {
    return {
      base_url: process.env.VUE_APP_API_URL,
      lang: "",
      col_number: 3,
      show_sav: false,
      TADR1: "",
      TADR2: "",
      TADR3: "",
      TCPAYS: "",
      TCPOST: "",
      TFAX_ADV: "",
      TLPAYS: "",
      TMAIL_ADV: "",
      TTEL_ADV: "",
      TVILLE: "",
    }
  },
  created() {

    let navigator_lang_mapping = {
      'fr': 'F',
      'en':'A',
      'de': 'D',
      'es': 'E',
      'it': 'I',
      'fr-FR': 'F',
      'en-EN': 'A',
      'de-DE':  'D',
      'es-ES': 'E',
      'it-IT': 'I',
      'fr-fr': 'F',
      'en-en': 'A',
      'de-de': 'D',
      'es-es': 'E',
      'it-it': 'I'
    };

    this.lang = this.$store.getters['application/get_application_user'].lang || navigator_lang_mapping[navigator.language];

    if( this.$store.getters['application/get_application_user'].id !== undefined &&
      this.$store.getters['application/get_application_company'].PCSOC !== undefined
    ) {
      customerService.getGeneralInfos().then(res => {
        if(res.data.DS_O !== undefined) {
          let infos = res.data.DS_O.OUT[0];

          this.ADR1 = infos.ADR1;
          this.TADR2 = infos.TADR2;
          this.TADR3 = infos.TADR3;
          this.TCPAYS = infos.TCPAYS;
          this.TCPOST = infos.TCPOST;
          this.TFAX = infos.TFAX;
          this.TFAX_ADV =  infos.TFAX_ADV;
          this.TINFOS_OUVERT = infos.TINFOS_OUVERT;
          this.TLPAYS =  infos.TLPAYS;
          this.TMAIL = infos.TMAIL;
          this.TMAIL_ADV = infos.TMAIL_ADV;
          this.TNOM = infos.TNOM;
          this.TNOMR = infos.TNOMR;
          this.TTEL = infos.TTEL;
          this.TTEL_ADV = infos.TTEL_ADV;
          this.TVILLE = infos.TVILLE;
        }


        this.show_sav = true;
      });
    } else {
      this.show_sav = false;
      this.col_number = 4;
    }
  }
};
</script>

<style scoped>
#footer {
  background-color: var(--c-black);
  padding: 90px 0px;
  min-height: 540px;
}

#footer .column-container {
  margin-top: 40px;
}

#footer .column-container img {
  max-width: 100%;
  width: 200px;
}

#footer h3 {
  color: #fff;
}

#footer li {
  list-style-type: none;
}

#footer a,
#footer span {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.804);
  margin: 10px 0px;
  display: block;
  font-size: var(--fz-sm);
}
</style>
